import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyDevAuthBootstrap } from './devAuth';
import { isEmergencyPath } from './emergency/emergencyPath';
import { initTheme } from './stores/theme.store';
import './styles/global.scss';

// Applique le thème clair/sombre (data-theme) avant le rendu.
initTheme();

// DEV-only: rebuild a real session from a stored token (see devAuth.ts).
// Jamais sur l'accès de secours (/secours) : il n'appelle pas le backend du panel.
if (!isEmergencyPath(window.location.pathname)) applyDevAuthBootstrap();

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
